export default __webpack_public_path__ + "static/yes-8b62cf8e0e699b73e90ca5ebab29e0db.svg";